module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-28.8900e626.jpg";